var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemIndent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M18 5v14.001a1 1 0 1 0 2 0V5a1 1 0 1 0-2 0m-7.387 3.488 2.409 2.446h-7.97C4.47 10.934 4 11.41 4 12s.47 1.066 1.05 1.066h7.97l-2.408 2.446a1.07 1.07 0 0 0-.308.754c0 .273.103.546.308.754.41.418 1.075.418 1.485 0l4.202-4.265a1.083 1.083 0 0 0 0-1.51L12.098 6.98a1.04 1.04 0 0 0-1.485 0 1.077 1.077 0 0 0 0 1.508"
})));
export default SvgGemIndent;